'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function zip() {
    for(var _len = arguments.length, arrs = new Array(_len), _key = 0; _key < _len; _key++){
        arrs[_key] = arguments[_key];
    }
    var rowCount = 0;
    for(var i = 0; i < arrs.length; i++){
        if (arrs[i].length > rowCount) {
            rowCount = arrs[i].length;
        }
    }
    var columnCount = arrs.length;
    var result = Array(rowCount);
    for(var i1 = 0; i1 < rowCount; ++i1){
        var row = Array(columnCount);
        for(var j = 0; j < columnCount; ++j){
            row[j] = arrs[j][i1];
        }
        result[i1] = row;
    }
    return result;
}
exports.zip = zip;
